module.exports = __webpack_public_path__ + "img/map.5068cfa4.png";